<template>
  <div v-if="visible || permanentMessage" style="z-index: 1000">
    <div v-if="discreteError || permanentMessage" class="limitedConnectivity">
      <v-icon style="margin-right: 20px">mdi-alert-outline</v-icon
      >{{ permanentMessage? permanentMessage : message}}
      <v-icon style="margin-left: 20px">mdi-alert-outline</v-icon>
    </div>
    <div v-else class="offlineModal">
      <div class="modal">
        <div class="close">
          <v-btn color="success" @click="closeOfflineModal()">Close</v-btn>
        </div>
        <span
          >Si &egrave; verificato un problema di comunicazione col
          server...</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "network-error",
  data() {
    return {
      visible: false,
      discreteError: false,
      message: this.$t("limited_connection"),
      permanentMessage: false,
      error: "",
    };
  },

  computed: {
    verifyNetworkError() {
      return this.$networkError.networkErrorRsp.visible;
    },
  },
  watch: {
    verifyNetworkError: function (error) {
      let _ = this;
      this.visible = this.$networkError.networkErrorRsp.visible;
      this.discreteError = this.$networkError.networkErrorRsp.discreteError;
      this.permanentMessage = this.$networkError.networkErrorRsp.permanentMessage;
      if (this.permanentMessage){
        setTimeout(
          function () {
            _.permanentMessage = false;
            _.$networkError.networkErrorRsp.visible = false;
              _.$networkError.networkErrorRsp.permanentMessage = false;
            }, 5000);
      }
      this.error = this.$networkError.networkErrorRsp.error;
      if (this.discreteError) {
        setTimeout(function () {
          _.visible = false;
        }, 10000);
      }
    },
  },
  created() {
    this.visible = this.$networkError.networkErrorRsp.visible;
    this.discreteError = this.$networkError.networkErrorRsp.discreteError;
    this.error = this.$networkError.networkErrorRsp.error;
  },
  methods: {
    closeOfflineModal() {
      this.visible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.offlineModal {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 10;
  padding: 25%;
  overflow: hidden;
  text-align: center;
}

.offlineModal .modal {
  background-color: white;
  width: 50%;
  height: 50%;
  position: fixed;
  top: 25%;
  left: 25%;
  border-radius: 5px;
  display: table;
}

.offlineModal .close {
  width: 50px;
  height: 50px;
  position: absolute;
  right: 70px;
  top: 20px;
  font-size: 25px;
}

.offlineModal .modal span {
  font-size: 20px;
  display: table-cell;
  vertical-align: middle;
}

.offlineModal::before {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);

  content: " ";
}
.limitedConnectivity {
  bottom: 0px;
  position: fixed;
  width: 100%;
  height: 29px;
  background-color: yellow;
  text-align: center;
  line-height: 30px;
  font-size: 20px;
  font-weight: bold;
  z-index: 1000;
}
</style>
